import React from 'react';
import log from 'loglevel';
import { ApiErrorMessage } from '../../../errors/ApiErrorMessage';

interface IErrorProps {
	error: Error;
}

export const SubmitError = ({ error }: IErrorProps) => {
	log.error('Details submit error', { error });

	return (
		<ApiErrorMessage
			error={error}
			genericMessage="web_parking_modify_personal_details_generic_error"
		/>
	);
};
